/*
TRANE CONFIDENTIAL

2021 – 2022 Copyright Trane U.S. Inc.
All Rights Reserved.

NOTICE: All information contained herein is, and remains the property of
Trane U.S. Inc. The source code, object code, intellectual and technical
concepts contained herein are proprietary to Trane U.S. Inc. and may be
covered by patents and patent applications and are protected by trade secret
and copyright law. Dissemination of this information or reproduction of this
material is strictly forbidden unless prior written permission is obtained
from Trane U.S. Inc. Do not use this software without the prior written
permission of Trane U.S. Inc.
*/

/* eslint-disable camelcase */
export const fr_ca_values = {
  code: "fr_ca",
  label: "Français",
};

export const fr_ca = {
  1: "#{LABEL}# ne peut pas être plus grand",
  3: "#{LABEL}# ne correspond pas",
  4: "#{LABEL}# est invalide",
  5: "#{LABEL}# est requis",
  6: "#{LABEL}# est trop tôt",
  7: "#{LABEL}# est trop tard",
  8: "#{LABEL}# doit être #{FIELDLENGTH}# caractères",
  9: "#{LABEL}# doit être #{FIELDMAXLENGTH}# caractères ou moins",
  12: "#{LABEL}# doit être au moins #{FIELDMIN}#",
  13: "#{LABEL}# doit être au moins #{FIELDMAX}# caractères",
  16: "#{LENGTH}# chiffre",
  17: "#{TITLE}# n'a pas encore de thermostats inscrits.",
  22: "Une journée doit avoir au moins une période.",
  24: "Restrictions d'accès",
  25: "Restrictions d'accès sauvegardées avec succès",
  26: "Les restrictions d'accès peuvent bloquer ou limiter les fonctionnalités et restreindre les paramètres de votre thermostat.",
  27: "Compte créé",
  28: "Récupération du compte",
  29: "Activer",
  30: "Code d'activation",
  31: "Ajouter une période",
  32: "Avancé",
  33: "Alerte envoyée lorsque la température est supérieure",
  34: "Alerte envoyée lorsque la température est inférieure",
  35: "Alertes",
  36: "Les alertes ont été enregistrées avec succès.",
  37: "Tout par ordre alphabétique",
  38: "Autoriser l'accès à toutes les fonctionnalités des écrans MENU et PARAMÈTRES permet à l'utilisateur de tout changer.",
  39: "Permet aux utilisateurs de démarrer une dérogation temporisée lorsqu'ils sont inoccupés ou de modifier les points de consigne de température sur l'écran ACCUEIL lorsqu'ils sont occupés.",
  40: "Une erreur est survenue.",
  41: "Erreur inconnue",
  43: "Paramètres de l'application",
  44: "Appliquer",
  45: "Appliquer #{LABEL}# à des thermostats supplémentaires?",
  47: "Appliquer une restriction d'accès aux thermostats supplémentaires?",
  48: "Appliquer des paramètres d'alerte à des thermostats supplémentaires?",
  49: "Appliquer les modifications à",
  50: "Etes-vous certain de vouloir changer votre NIP?",
  51: "Etes-vous certain de vouloir effacer toutes les notifications d'alerte?",
  52: "Etes-vous certain de vouloir supprimer #{NAME}#?",
  53: "Etes-vous certain de vouloir supprimer ce bâtiment?",
  54: "Etes-vous certain de vouloir supprimer cet utilisateur?",
  55: "Etes-vous certain de vouloir supprimer ceci?",
  56: "Etes-vous certain de vouloir vous déconnecter?",
  57: "Etes-vous certain de vouloir supprimer #{NAME}# de Pivot?",
  59: "Type d'Authentification",
  64: "Configuration du tableau de bord",
  65: "Construction d'un tableau de bord",
  66: "Détails du bâtiment",
  67: "En accédant à l'application Pivot, vous acceptez et consentez d'être lié par les",
  68: "Appeler le Support #{PHONENUMBER}#",
  69: "Annuler",
  70: "Impossible de créer une nouvelle période. Il y a un maximum de #{MAXOCCPERIODSPERDAY}# périodes par jour.",
  71: "Changer #{TITLE}# à #{LABEL}#",
  73: "Changer #{MODELABEL}# à #{OPTIONLABEL}#",
  74: "Changer #{TITLE}# à #{LABEL}#",
  77: "Effacer",
  78: "Tout effacer",
  79: "Compresseur",
  80: "Vitesse du compresseur",
  81: "Confirmer votre NIP",
  83: "Continuer",
  87: "Refroidir à",
  88: "Refroidir à: {setpoint}°",
  89: "Refroidir à | {setpoint}. Chauffer à | {setpoint} °",
  93: "Créer un groupe",
  94: "Chaque jour",
  95: "Tableau de bord",
  96: "Effacer",
  97: "Supprimer",
  98: "Démo - la sauvegarde ne s'effectue pas",
  99: "Commande de périphériques",
  100: "Périphériques",
  102: "Les périphériques d'abord (défault)",
  103: "Accès désactivé à l'écran MENU et au MODE SYSTÈME et MODE VENTILATEUR, mais permet le réglage du point de consigne de la température et les remplacements temporisés.",
  104: "Accès désactivé à l'écran MENU, mais permet les changements de SYSTÈME et de MODE VENTILATEUR ainsi que le réglage du point de consigne de température et les remplacements chronométrés.",
  105: "Dissocier de votre Compte",
  106: "REJETER",
  107: "Terminé",
  109: "Modifier Groupe",
  110: "Courriel",
  111: "Adresse courriel",
  112: "Adresse courriel invalide",
  113: "Adresse courriel requise",
  114: "Assistance par courriel",
  115: "Permettre à l'entrepreneur de service de voir les informations sur vos thermostats",
  116: "Ajout périphérique",
  117: "L'inscription a échoué.",
  118: "Entrez votre code d'activation à 12 chiffres",
  119: "Entrez votre adresse courriel et nous vous enverrons un courriel pour récupérer votre nom d'utilisateur.",
  120: "Entrer votre NIP",
  122: "Saisissez votre nom d'utilisateur et nous vous enverrons un courriel pour réinitialiser votre mot de passe.",
  123: "Les entrées ne correspondent pas, veuillez saisir à nouveau votre code NIP.",
  124: "Evénements",
  125: "Sortir Démo",
  126: "Explorer Démo",
  127: "Échec de la modification de #{TITLE}# en #{LABEL}#",
  128: "Impossible de charger le programme actif du thermostat. Voulez-vous choisir un horaire enregistré?",
  131: "Pour votre sécurité, nous ne pouvons pas confirmer si le #{PROVIDEDCREDENTIAL}# que vous avez entré était correct. Si vous ne recevez pas de courriel, essayez de nouveau et assurez-vous que votre #{PROVIDEDCREDENTIAL}# est entré correctement.",
  132: "Vous avez oublié votre NIP",
  133: "Obtenir un code d'activation",
  134: "Obtenir un code",
  135: "Revenir",
  137: "Groupes d'abord",
  140: "Chauffer à",
  141: "Chauffer à | {setpoint}°",
  142: "Chauffer à | #{setpoint}#. Refroidir à | {setpoint}°",
  144: "Aide",
  145: "Haut",
  146: "fr_Space Temperature Alert Enabled_fr",
  147: "Historique",
  148: "Humidité",
  149: "J'ai oublié mon nom d'utilisateur ou mon mot de passe",
  150: "Je comprends les risques",
  151: "Si vous êtes prêt à ajouter un thermostat à #{TITLE}# appuyez sur le bouton Inscrire un Nouveau Périphérique ci-dessous.",
  152: "Si vous continuez, cet utilisateur ne pourra plus rien contrôler dans votre compte tant que vous n'aurez pas terminé le processus d'activation. Voulez-vous vraiment générer un nouveau code d'activation pour cet utilisateur?",
  153: "Si vous ne recevez pas de courriel, veuillez vérifier votre dossier de courrier indésirable et vous assurer que vous ne bloquez pas les courriels #{SUPPORT}#.",
  154: "NIP invalide. Veuillez réessayer.",
  156: "Le code d'accès du menu principal nécessite des restrictions d'accès définies sur Faible, Moyenne ou Élevée.",
  157: "Dernière mise à jour #{TIME}#",
  158: "Informations de licence",
  160: "Charger",
  162: "Chargement en cours '#{BUILDINGNAME}#'",
  163: "Chargement de l'inscription du compte",
  164: "Chargement des alertes",
  165: "Chargement du bâtiment",
  166: "Chargement de l'historique d'exécution quotidienne...",
  167: "Chargement des horaires par défaut",
  168: "Chargement des périphériques...",
  169: "Chargement de l'historique d'exécution mensuelle...",
  170: "Chargement de la réinitialisation du mot de passe",
  171: "Chargement de la liste des horaires",
  172: "Chargement des points de consigne",
  173: "Chargement du programme du thermostat",
  174: "Chargement en cours...",
  175: "Connexion",
  176: "Déconnexion",
  177: "Ouverture de session",
  178: "Bas",
  179: "Gérer les Utilisateurs",
  180: "Fabricant ",
  181: "Moyen",
  184: "Mensuel",
  185: "Plus",
  186: "Mes Bâtiments",
  187: "Nom",
  188: "Nouveau Code d'Activation",
  189: "Nouveau Bâtiment",
  190: "Nouvelle Période",
  191: "Nouvel Utilisateur",
  192: "Non",
  193: "Aucune alerte n'est activée",
  194: "Aucune autorisation",
  196: "Aucune activité récente trouvée.",
  197: "Aucun",
  198: "Veuillez sélectionner un bâtiment pour permettre la création de groupes et l'inscription des périphériques.",
  200: "Occupation des points de consignes",
  201: "Occupé",
  202: "Temps occupé restant",
  204: "OK",
  206: 'Informations sur la licence "Open Source"',
  207: "Opération complétée",
  208: "Version OS ",
  209: "Dehors",
  210: "Réinitialisation du mot de passe réussie.",
  213: "Saisie du NIP désactivée pendant #{MINUTES}# minutes.",
  214: "Longueur du NIP",
  215: "Le NIP a bien été enregistré.",
  216: "Version de l'application mobile Pivot",
  217: "Application mobile Pivot ™",
  218: "Plateforme",
  219: "Veuillez saisir un nouveau NIP",
  220: "Soyez prudent lorsque vous supprimez l'autorisation d'un utilisateur de l'application. En raison du risque d'accès non autorisé, Pivot recommande fortement de garder l'application verrouillée à moins que cet appareil mobile ne dispose d'un écran de verrouillage",
  221: "Veuillez remplir les informations suivantes pour réinitialiser votre mot de passe.",
  222: "Veuillez ressaisir votre nom d'utilisateur et votre mot de passe pour gérer les utilisateurs de votre compte Pivot ™. Vous n'aurez pas à recommencer.",
  223: "Pointé vers #{HOST}#",
  224: "Code postal",
  225: "Politique de confidentialité",
  226: "Récupérer le nom d'utilisateur",
  228: "Actualiser les périphériques",
  229: "Supprimer #{NAME}# de Pivot",
  230: "Supprimer la période",
  231: "Réinitialiser le NIP",
  232: "Réinitialiser le mot de passe",
  233: "Redémarrez l'application",
  234: "Empêchez l'accès non autorisé au thermostat à l'aide d'un code d'accès.",
  235: "Restrictions|Niveau d'accès",
  236: "Restrictions|Mot de passe",
  237: "Récupération de l'historique d'exécution quotidien",
  238: "Récupération de l'historique d'exécution mensuel",
  239: "Ré-essayer",
  240: "Historique d'exécution",
  241: "Enregistrer",
  242: "Enregistrer sous",
  243: "Horaires sauvegardés",
  244: "Enregistrement de la restriction d'accès...",
  245: "Sauvegarder les alertes",
  246: "Horaires",
  247: "La planification n'a pas pu être activée. Veuillez réessayer plus tard.",
  248: "Planification activée.",
  249: "La programmation est désactivée sur ce thermostat. Activer la planification?",
  250: "CHOISIR UNE PAGE",
  251: "Envoyer des suggestions ou des commentaires",
  252: "Service Non Disponible",
  253: "Définissez un NIP de #{LENGTH}# - chiffres",
  254: "Définir un NIP à 8 chiffres",
  255: "Points de consigne (PdC)",
  256: "Réglage du froid sur #{SETPOINTCOOL}#",
  257: "Réglage de la chaleur sur #{SETPOINTHEAT}#",
  258: "Régler la chaleur à #{SETPOINTHEAT}# et refroidir à #{SETPOINTCOOL}#",
  259: "Paramètres",
  260: "Se connecter",
  261: "S'inscrire",
  262: "S'inscrire maintenant",
  264: "Une erreur s'est produite lors de l'affichage de cette page.",
  266: "Soumettre",
  267: "Enregistré avec succès #{NAME}#.",
  268: "Support & Commentaires",
  270: "Termes and Conditions",
  271: "Termes d'Utilisation",
  272: "Merci. Vous devriez recevoir un courriel sous peu avec #{REQUESTEDEMAIL}#. Le courriel peut prendre de 5 à 10 minutes pour arriver.",
  274: "Les séries de mesure d'Open Source suivants sont utilisés par l'application mobile Pivot ™.",
  275: "La période suivante est trop proche pour créer une nouvelle période.",
  276: "La période précédente est trop proche pour créer une nouvelle période.",
  277: "La demande a expiré.",
  280: "Thermostats",
  281: "Cette action ne peut pas être effectuée car votre compte doit inclure au moins un bâtiment.",
  282: "Ce groupe est vide. Modifiez le groupe pour ajouter des périphériques.",
  283: "Cet appareil mobile doit être authentifié de nouveau.",
  284: "Cette opération ne peut pas être effectuée lorsque le périphérique est hors ligne.",
  285: "Ce thermostat n'est pas compatible avec Pivot",
  286: "Pour configurer des alertes pour un thermostat individuel, cliquez sur l'icône Paramètres -",
  287: "Pour inscrire ce thermostat sous #{BUILDINGNAME}#, cliquez sur Obtenir le code pour générer un Code à 5 chiffres à saisir sur le thermostat.",
  288: 'Pour inscrire ce thermostat sous un autre bâtiment, cliquez sur "Tableau de Bord", sélectionnez le bâtiment souhaité, puis sélectionnez de nouveau Enregistrz un Périphérique dans le menu.',
  289: "fr_To subscribe or modify your subscribed alerts press the Alert Subscriptions button above._fr",
  291: "Annuler",
  292: "Désinscription #{NAME}#",
  294: "Déverrouiller l'Application",
  295: "fr_Unlock with Biometrics_fr",
  296: "Déverrouiller avec le NIP",
  297: "Déverrouiller avec le NIP seulement",
  298: "Inoccupé",
  299: "Utiliser un code à 12 chiffres",
  300: "Nom d'utilisateur",
  301: "Nom d'utilisateur et Mot de passe",
  302: "Nom d’utilisateur requis",
  303: "Utilisateurs",
  304: "Version",
  305: "Nous ne pouvons pas communiquer avec les serveurs de Pivot. Un accès Internet est requis pour que cette application fonctionne correctement. Veuillez vérifier vos données ou vos paramètres Wi-Fi et réessayer.",
  306: "Bienvenue chez Pivot",
  307: "Oui",
  309: "Vous ne pouvez pas supprimer la dernière période.",
  310: "Vous n'avez pas encore d'horaires enregistrés.",
  311: "Votre compte a été créé. Veuillez prendre un moment pour remplir quelques détails supplémentaires.",
  312: "Votre réseau n'est pas disponible. Vérifiez vos données ou votre connexion Wi-Fi.",
  313: "Le nom de la période ne peut pas être vide",
  314: "Le nom de la période ne peut pas contenir d'émojis ou de caractères spéciaux.",
  315: "Alertes du thermostat par défaut activées",
  316: "Enregistrement des points de consigne...",
  317: "Consignes enregistrées avec succès.",
  318: "Erreur inattendue",
  319: "Appliquer des points de consigne à des thermostats supplémentaires?",
  320: "Souhaitez-vous utiliser votre NIP pour déverrouiller l'application lorsque vous l'ouvrez?",
  321: "Souhaitez-vous utiliser votre #{BIOMETRIC STRING}# pour déverrouiller l'application lorsque vous l'ouvrez? Votre code NIP sera utilisé si la #{BIOMETRIC STRING}# échoue.",
  322: "Entrez votre nom d'utilisateur et votre mot de passe Pivot pour réinitialiser votre NIP",
  323: "Sauvegarder NIP",
  324: "NIP sauvegardé avec succès",
  325: "Appliquer des NIP à des thermostats supplémentaires?",
  326: "Le code NIP doit être composé de quatre chiffres",
  327: "Code d'accès au menu principal activé",
  328: "Code d'accès au menu à 4 chiffres",
  329: "Code d'accès du technicien activé",
  330: "Code d'accès du menu technicien à 4 chiffres",
  331: "pour ce thermostat",
  332: "Notre équipe de développeurs a été informée du problème et travaille à corriger la situation.",
  333: "La page ne peut pas être trouvée",
  334: "Sauvegarder",
  335: "Dire #{NAME}# à #{ACTION}#",
  336: "Cette action ne peut pas être effectuée car ce bâtiment contient des périphériques inscrits.",
  337: "Détails du périphérique",
  338: "Le thermostat n'est pas connecté en ce moment",
  339: "Termes et conditions du contrat de licence final de l'utilisateur.",
  340: "Voulez-vous vraiment annuler les modifications apportées au programme?",
  341: "Jeter",
  342: "Vous devez donner un nom au programme.",
  343: "Horaire sauvegardé",
  344: "Calendrier actuel enregistré sous #{NAME}#",
  345: "Enregistrement de l'horaire",
  346: "[#{NAME}#] existe déjà.\nVoulez-vous le remplacer?",
  347: "Impossible de charger cette planification",
  348: "#{NAME}# est invalide et ne peut être chargé",
  349: "#{NAME}# ne correspond pas à l'échelle de température du thermostat.",
  350: "Supprimer '#{NAME}#'",
  351: "Enregistrement du programme du thermostat",
  352: "Enregistrement des horaires...",
  353: "Les horaires ont bien été enregistrés.",
  354: "Appliquer le programme à des thermostats supplémentaires?",
  355: 'Chargé "#{NAME}#"',
  356: "Il n'y a encore rien ici.",
  357: "Note",
  358: "Le mode démo vous permet de naviguer dans l'application Pivot et d'explorer son fonctionnement. Lorsque vous utilisez l'application Pivot dans ce mode, les modifications que vous apportez ne sont pas enregistrées.",
  359: "Langue",
  360: "Définir automatiquement via ce périphérique",
  361: "Enregistrement de la langue...",
  362: "Choisir la langue",
  363: "Une valeur est requise.",
  364: "Éditer",
  365: "Calendrier actif",
  366: "Code de support",
  367: "Version Chrome",
  368: "Affichage Web",
  369: "Inconnue",
  370: "Mot de passe",
  371: "Utilisateur mobile",
  372: "Code de support",
  373: "MODE CHAUD",
  374: "FROID",
  375: "ARRÊT",
  376: "Date trop tôt",
  377: "Date trop tard",
  378: "sur",
  379: "à",
  380: "par",
  381: "Événement de périphérique",
  382: "Événement programmé",
  383: "Navigateurs Web",
  384: "Abonnements aux alertes",
  385: "Filtre",
  386: "Inscrire #{DEVICE}#",
  387: "Inscription #{DEVICE}#",
  388: "lun",
  389: "mar",
  390: "mer",
  391: "jeu",
  392: "ven",
  393: "sam",
  394: "dim",
  395: "FR - Are you sure you want to reset your password? - FR",
  396: "Alerte envoyée lorsque la humidité est supérieure",
  397: "Alerte envoyée lorsque la humidité est inférieure",
  398: "fr_Space Humidity Alert Enabled_fr",
  399: "FR_The software included in this product contains copyrighted software that is licensed under the GPL, LGPL or other copyleft license. A copy of those licenses is included herewith.  You may obtain the complete corresponding source code from us for a period of three years after our last shipment of this product by sending a request letter to:",
  400: "Trane Commercial HVAC",
  401: "Attn: Open Source Compliance",
  402: "800-E Beaty St.",
  403: "PO Box 940",
  404: "Davidson, NC 28036",
  405: "Please include the name of the product and, if applicable, the version number of the software in the request letter. This offer is valid to anyone in receipt of this information._FR",
  406: "fr_To transfer your account, please enter your password:_fr",
  407: "fr_Transfer Account_fr",
  409: "fr_Loading Account Transfer_fr",
  410: "fr_Hello!_fr",
  411: "fr_Please fill out the fields below in order to activate the Pivot account that was transferred to you._fr",
  412: "fr_Thermostat Fault Alerts_fr",
  413: "fr_Enabled_fr",
  414: "fr_Disabled_fr",
  415: "fr_High Low Temperature Alert_fr",
  416: "fr_Humidity Alert_fr",
  417: "fr_above_fr",
  418: "fr_below_fr",
  419: "fr_Send alert notification on:_fr",
  420: "fr_Alert Enabled_fr",
  421: "fr_Alert_fr",
  422: "fr_Username is permanently tied to account.  Create a username meaningful to the owner._fr",
  423: "fr_Alert Subscription Users_fr",
  424: "fr_Thermostats this user can control_fr",
  425: "fr_Add Contact_fr",
  426: "fr_Receives selected alerts at_fr",
  427: "fr_Edit Settings_fr",
  428: "fr_Delete contact_fr",
  429: "fr_User alert subscriptions_fr",
  430: "fr_Send to_fr",
  431: "fr_At_fr",
  432: "fr_Phone Number_fr",
  433: "fr_All_fr",
  434: "fr_Custom_fr",
  435: "fr_Receive these alerts_fr",
  436: "fr_High and low limit cannot be same_fr",
  437: "fr_Higher limit must be greater than lower limit_fr",
  438: "fr_My push notification alerts_fr",
  439: "fr_this Mobile Device_fr",
};



// WEBPACK FOOTER //
// ../nx-components/src/Locales/fr_ca_core.js